import React, {Component} from 'react';
import ReactPlayer from 'react-player';
import ChatBox from '../chat/ChatBox';
import styles from './VideoPlayerWithChat.module.css';
class VideoPlayerWithChat extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={styles.videoPlayerContainer}>
        <ReactPlayer
          width={'100%'}
          height={'62.25%'}
          url={this.props.source}
          controls={true}
          className={styles.videoPlayer}
          onPlay={this.props.onPlay}
        />
        <div className={styles.chatBoxContainer}>
          <ChatBox
            chatLogUrl={this.props.chatLogUrl}
            className={styles.chatBox}
          />
        </div>
      </div>
    );
  }
}

export default VideoPlayerWithChat;
